var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0077 10.765C26.0232 10.9901 26.0232 11.2152 26.0232 11.4424C26.0232 18.3649 20.7793 26.3486 11.1907 26.3486V26.3445C8.35814 26.3486 5.58447 25.5332 3.19995 23.9958C3.61182 24.0456 4.02576 24.0705 4.44073 24.0716C6.78808 24.0736 9.06834 23.2821 10.915 21.8246C8.68434 21.7821 6.72821 20.3204 6.04485 18.1865C6.82627 18.3379 7.63143 18.3068 8.3984 18.0962C5.9664 17.6024 4.21673 15.455 4.21673 12.9612C4.21673 12.9383 4.21673 12.9166 4.21673 12.8948C4.94137 13.3004 5.75273 13.5255 6.58266 13.5504C4.29208 12.012 3.58602 8.9496 4.96924 6.55531C7.61595 9.82827 11.521 11.818 15.713 12.0286C15.2929 10.209 15.8668 8.30227 17.2211 7.02317C19.3207 5.03969 22.6229 5.14136 24.5966 7.25036C25.7641 7.01903 26.883 6.58851 27.907 5.97853C27.5179 7.19123 26.7034 8.22136 25.6154 8.87595C26.6487 8.75353 27.6583 8.47551 28.609 8.05122C27.9091 9.10521 27.0276 10.0233 26.0077 10.765Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.455e3e4783ed27902ea5bb34ad8d3e5b.svg";
export { ForwardRef as ReactComponent };